var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length > 0)?_c('div',{staticClass:"base-errors",style:(_vm.errorsStyle)},[_c('span',[_vm._v("Что-то пошло не так:")]),_vm._v(" "),_vm._l((_vm.errors),function(error){return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error-info"},[_vm._v(_vm._s(error))])])})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05bb9d8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Manager/Shared/BaseErrors.vue
// module id = null
// module chunks = 